export class AlertMessage {
    time: number;
    title: string;
    message: string;
    iconClassName: string;
    extra: any;

    constructor() {
        this.time = Date.now();
        this.iconClassName = 'fa fa-credit-card';
    }

    toggleState() {
        this.title = this.title + '_TOGGLED';
    }
}
